import { EnumOrderType } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Exp/EnumOrderType';
import { Condition } from './Condition';

export class OrderItem {
  key: string;
  OrderType: EnumOrderType;
  condition: Condition;
}
